import { BlinqLogo } from '@components/BlinqAssets';
import TopNav, { AlignedContent } from '@components/TopNav/TopNav';
import type { FC } from 'react';

import styles from './BlinqTopNav.module.scss';

interface BlinqTopNavProps {
  showMobileOptionBars?: boolean;
}

const BlinqTopNav: FC<React.PropsWithChildren<BlinqTopNavProps>> = () => {
  return (
    <TopNav size="small">
      <AlignedContent align="left">
        <BlinqTopNavLogo />
      </AlignedContent>
    </TopNav>
  );
};
export const BlinqTopNavLogo = () => {
  return (
    <div className={styles['blinq-logo-container']}>
      <BlinqLogo className={styles['blinq-logo']} />
    </div>
  );
};

export default BlinqTopNav;
